// src/components/layouts/app/header/desktop/SectorDropdown.tsx
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChevronDown, 
  Laptop, 
  Building2, 
  ShoppingBag, 
  Briefcase, 
  Hotel 
} from 'lucide-react';

const sectors = [
  { id: 'informatique', name: 'Informatique & Bureautique', icon: Laptop, path: '/secteurs/informatique' },
  { id: 'btp', name: 'BTP & Énergie', icon: Building2, path: '/secteurs/btp-energie' },
  { id: 'commerce', name: 'Commerce & Distribution', icon: ShoppingBag, path: '/secteurs/commerce-distribution' },
  { id: 'consulting', name: 'Services & Consulting', icon: Briefcase, path: '/secteurs/consulting' },
  { id: 'hotellerie', name: 'Hôtellerie & Restauration', icon: Hotel, path: '/secteurs/hotellerie' },
];

export const SectorDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = window.setTimeout(() => {
      setIsOpen(false);
    }, 150);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div 
      className="relative" 
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-md text-black hover:text-primary hover:bg-gray-100 transition-all duration-200"
      >
        <Briefcase className="w-4 h-4" />
        <span>Nos secteurs</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Menu avec animation fluide (identique au MegaMenu) */}
      <div
        className={`
          absolute top-full left-0 mt-2 w-64 bg-white border border-gray-200 rounded-xl shadow-lg z-20
          transition-all duration-300 ease-out origin-top
          ${isOpen 
            ? 'opacity-100 scale-y-100 visible pointer-events-auto' 
            : 'opacity-0 scale-y-0 invisible pointer-events-none'
          }
        `}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="py-2">
          {sectors.map((sector) => (
            <Link
              key={sector.id}
              to={sector.path}
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-black hover:bg-gray-50 hover:text-primary transition-colors duration-150"
            >
              <sector.icon className="w-4 h-4 text-primary" />
              {sector.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};